function getConfig() {
  if (localStorage.getItem("config"))
    return JSON.parse(localStorage.getItem("config"));
  else return null;
}

function hasRole(key) {
  var r = getConfig().roles.find((f) => f == key);
  if (r) return true;
  else return false;
}

export { getConfig, hasRole };
